// Vendor
import { createAction, props } from '@ngrx/store';
export const setFundChartPartner = createAction('[Fund Chart] Set partner', props());
